<template>
  <v-dialog
    v-model="dialog"
    scrollable
    persistent
    transition="dialog-bottom-transition"
    width="50%"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        class="mr-5 white--text"
        color="primary"
        v-on="on"
        :loading="loading"
        @click="execute"
      >
        <v-icon small left>
          mdi-database-sync-outline
        </v-icon>
        <span>Execute</span>
      </v-btn>
    </template>
    <v-card class="pa-0">
      <v-toolbar flat>
        <v-toolbar-title>
          Datasets Execution
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn icon @click="handleClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text id="select-table-columns-list">
        <template v-if="loading">
          <div class="text-center mt-5 mb-3">
            <v-icon size="65" class="pb-2">
              mdi-cloud-search-outline
            </v-icon>
            <div class="display-1 font-weight-light">
              Retrieving data
            </div>
            <p class="caption">
              We are retrieving any available data in for this dataset. Please
              wait....
            </p>
          </div>
        </template>
        <template v-else-if="discovery_errors.length > 0">
          <div class="text-center mt-5 mb-3 ">
            <v-icon size="65" class="pb-2">
              mdi-cloud-alert
            </v-icon>

            <div class="display-1 font-weight-light">
              Error while retrieving your data
            </div>
            <v-alert
              dense
              outlined
              type="error"
              icon="mdi-cloud-alert"
              class="text-left mt-5"
            >
              <div
                v-for="(e, index) in discovery_errors"
                :key="index"
                class="body-1"
              >
                {{ e }}
              </div>
            </v-alert>
          </div>
        </template>
        <template v-else>
          <div class="text-center mt-5 mb-3">
            <v-icon size="65" class="pb-2">
              mdi-database-check-outline
            </v-icon>
            <div class="display-1 font-weight-light">
              Dataset filled.
            </div>
          </div>
        </template>
      </v-card-text>
      <v-divider />
      <v-card-actions class="text-right">
        <v-col cols="12" class="d-inline-flex justify-center pt-2 pb-2">
          <v-btn class="mx-2" text @click="handleClose">
            Cancel
          </v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import SingerService from "./services/SingerService";

export default {
  props: {
    tap_id: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      discovery_errors: []
    };
  },
  computed: {
    innerHeight: function() {
      return window.innerHeight;
    }
  },
  methods: {
    handleReset() {
      this.loading = false;
    },
    handleClose() {
      let self = this;
      this.dialog = false;
      this.cancelToken();
      _.delay(() => {
        self.loading = false;
      }, 500);
    },
    execute() {
      let self = this;
      this.loading = true;
      let cancelToken = new axios.CancelToken(function(c) {
        self.cancelToken = c;
      });
      SingerService.execute(self.tap_id, { cancelToken: cancelToken })
        .catch(function(error) {
          self.discovery_errors = error.response.data.error;
          if (!cancelToken.reason) {
            self.$store.commit("push", {
              msg: _.join(error.response.data.error, "\n"),
              color: "error"
            });
          }
        })
        .finally(() => {
          self.loading = false;
          self.dialog = false;
          self.$emit("tapExecutionFinished");
        });
    }
  }
};
</script>

<style scoped></style>
